/** Biçimlendirme yardımcıları. Para ve tarih tek yerden geçer. */
import { ANA_PARA_BIRIMI, paraBirimiNormalle } from './paraBirimi.js';
/**
 * Biçimleyici ÖNBELLEĞİ.
 *
 * `new Intl.NumberFormat(...)` pahalıdır; kasa listesinde satır başına
 * çağrılırsa ölçülebilir yavaşlama yapar. Para birimi başına bir kez
 * kurulur ve saklanır.
 */
const BICIMLEYICILER = new Map();
function bicimleyici(birim) {
    let b = BICIMLEYICILER.get(birim);
    if (!b) {
        b = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: birim,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        BICIMLEYICILER.set(birim, b);
    }
    return b;
}
const SAYI = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 });
/**
 * Parayı biçimler. İkinci değiştirge verilmezse TL — böylece bu işlevi
 * çağıran onlarca eski satır olduğu gibi çalışmaya devam eder.
 *
 *   para(1500)          → "₺1.500,00"
 *   para(400, 'EUR')    → "€400,00"
 */
export function para(deger, birim = ANA_PARA_BIRIMI) {
    return bicimleyici(paraBirimiNormalle(birim)).format(Number(deger) || 0);
}
export function sayi(deger) {
    return SAYI.format(Number(deger) || 0);
}
/** Kuruş kaybı olmadan toplama için: tutarlar iki basamağa yuvarlanır. */
export function kurus(deger) {
    return Math.round((Number(deger) || 0) * 100) / 100;
}
export function bugun() {
    return yerelTarih(new Date());
}
export function yerelTarih(d) {
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
export function yerelSaat(d) {
    const p = (n) => String(n).padStart(2, '0');
    return `${p(d.getHours())}:${p(d.getMinutes())}`;
}
/**
 * SAAT DİLİMİ EKİ VAR MI — 'Z' ya da '+03:00' / '-05:30'.
 *
 * Nero'nun bugünkü zaman damgaları YEREL saattir ve eksizdir
 * ('2026-09-07 14:22:10'); onları çevirmek 3 saat kaydırırdı. Eki olan bir
 * değer ise mutlak bir andır ve yerele çevrilmelidir. Bu ayrım
 * ZAMAN-DAMGASI-PLANI.md adım 2'nin tamamıdır: okuma katmanı iki biçimi de
 * kabul eder, yazma katmanı bu turda hiç değişmez.
 */
const DILIM_EKI = /(?:Z|[+-]\d{2}:?\d{2})$/i;
/** Ekli değeri gerçek tarihe çevirir; çözülemezse null döner. */
function mutlakTarih(iso) {
    if (!DILIM_EKI.test(iso))
        return null;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? null : d;
}
const iki = (n) => String(n).padStart(2, '0');
/** 2026-08-31 -> 31.08.2026 · 2026-09-07T23:30:00Z -> 08.09.2026 (yerel) */
export function tarihGoster(iso) {
    if (!iso)
        return '—';
    const d = mutlakTarih(iso);
    if (d)
        return `${iki(d.getDate())}.${iki(d.getMonth() + 1)}.${d.getFullYear()}`;
    /* Çözülemeyen metin OLDUĞU GİBİ döner: uydurma bir tarih göstermek, ham
       değeri göstermekten kötüdür. Saat dilimi eki taşıyıp da çözülemeyen bir
       değer de buraya düşer — onu dilimlemek "2026-13-45" gibi bir çöpü
       "45.13.2026" diye geçerli göstermek olurdu. */
    if (DILIM_EKI.test(iso))
        return iso;
    const e = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!e)
        return iso;
    const [, yil, ay, gun] = e;
    if (Number(ay) < 1 || Number(ay) > 12 || Number(gun) < 1 || Number(gun) > 31)
        return iso;
    return `${gun}.${ay}.${yil}`;
}
export function tarihSaatGoster(iso) {
    if (!iso)
        return '—';
    const d = mutlakTarih(iso);
    if (d) {
        return `${iki(d.getDate())}.${iki(d.getMonth() + 1)}.${d.getFullYear()}`
            + ` ${iki(d.getHours())}:${iki(d.getMinutes())}`;
    }
    const t = tarihGoster(iso);
    if (t === iso)
        return iso; /* çözülemedi — ham değer */
    const s = iso.length > 10 ? iso.slice(11, 16) : '';
    return /^\d{2}:\d{2}$/.test(s) ? `${t} ${s}` : t;
}
/** Plakayı tek biçime indirger: boşluksuz, büyük harf. */
export function plakaNormalle(deger) {
    /* Türk plakalarında Ç Ğ İ Ö Ş Ü kullanılmaz; bu yüzden Türkçe büyük harf
       kuralı YANLIŞ olur: "ist" → "İST" olur ve [A-Z] süzgecinden düşerdi.
       Düz büyük harf kuralı doğru sonucu verir: "ist" → "IST". */
    return (deger || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
}
/** 34 ABC 123 gibi okunur hale getirir. */
/**
 * ARAÇSIZ İŞ EMRİNDE plaka yerine yazılan etiket.
 *
 * Tek yerde durur: sekiz ayrı ekranda elle yazılsaydı biri "Araçsız",
 * biri "Araç yok", biri "—" derdi ve aynı kayıt her ekranda başka
 * görünürdü.
 */
export const ARACSIZ = 'Araçsız';
export function plakaGoster(deger) {
    /* ARAÇSIZ İŞ EMRİ: plaka NULL gelebilir (bkz. tipler.ts · IsEmriOzet).
       Boş dönmek, "null" yazmaktan da çağıran her yere `?? ''` serpmekten
       de iyidir; gösterilecek etiketi çağıran seçer. */
    if (!deger)
        return '';
    const p = plakaNormalle(deger);
    const m = /^(\d{2})([A-Z]{1,3})(\d{2,5})$/.exec(p);
    return m ? `${m[1]} ${m[2]} ${m[3]}` : deger;
}
export function telefonNormalle(deger) {
    return (deger || '').replace(/[^0-9+]/g, '');
}
/** Türkçe duyarlı, aksan/harf farkını yok sayan arama anahtarı. */
export function aramaAnahtari(deger) {
    return (deger || '')
        .toLocaleLowerCase('tr-TR')
        .replace(/ı/g, 'i')
        .replace(/İ/g, 'i')
        .replace(/ş/g, 's')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .trim();
}
export function boyutGoster(bayt) {
    if (bayt < 1024)
        return `${bayt} B`;
    if (bayt < 1024 * 1024)
        return `${(bayt / 1024).toFixed(0)} KB`;
    return `${(bayt / 1024 / 1024).toFixed(1)} MB`;
}
//# sourceMappingURL=bicim.js.map